import { fr } from './fr';
import { en } from './en';

export const translations = { fr, en };

export const LANGUAGES = [
  { code: 'fr', label: 'FR', name: 'Français' },
  { code: 'en', label: 'EN', name: 'English' },
];
